<template> 
	<div class="compare-block compare-text-infor industrialPie">
	<!-- <div class="compare-view-scroll compare-text-infor"> -->
<table  border="0" cellspacing="0" cellpadding="0"  width="100%">
	<!-- 重点产业分布 -->
		<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3 tac">重点产业分布</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<div :id="'compare-industrialPie'+(i+1)"></div>
			</td>
			<!-- 表格数据不够自动补全单元格 -->
			<td class="a-compare-company p-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>

	<!-- 政策名称 -->
		<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3 tac">政策名称</h5>
			</td>
			<td class="a-compare-company p-3" :key="i" v-for="(list,i) in compareList">
				<span class="line-height-25">上海青浦区加强招商引资和产业项目推进实施方案</span>
			</td>
			<!-- 表格数据不够自动补全单元格 -->
			<td class="a-compare-company p-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>

		<!-- 发展目标 -->
		<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3 tac">发展目标</h5>
			</td>
			<td class="a-compare-company p-3 line-height-25 text-dent-2" :key="i" v-for="(list,i) in compareList">
				<p>(一)确保每年引进亿元以上项目到位资金和项目个数保持全市领先，其中到位长三角地区资金年均增长10%以上，</p>
				<p>(二)每年新建5亿元以上项目5个，10亿元以上项目2个、20亿元以上项目1个、力争3年内招引50亿元以上项目1个。</p>
			</td>
			<!-- 表格数据不够自动补全单元格 -->
			<td class="a-compare-company p-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>

		<!-- 重点发展方向 -->
		<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3 tac">重点发展方向</h5>
			</td>
			<td class="a-compare-company p-3" :key="i" v-for="(list,i) in compareList">
				<p>(一)拓展渠道，开展外资引进行动</p>
				<p>(二)顶格推进，开展招大引强行动</p>
			</td>
			<!-- 表格数据不够自动补全单元格 -->
			<td class="a-compare-company p-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>

		<!-- 招商引资项目对比 -->
		<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3 tac">招商引资项目对比</h5>
			</td>
			<td class="a-compare-company p-3" :key="i" v-for="(list,i) in compareList">
				<p>上市公司数量:50个</p>
				<p>上市公司投资项目金额:203亿元</p>
				<p>企业拿地投资项目数量:130个</p>
				<p>企业拿地投资项目面积:52364亩</p>
				<p>企业拿地投资项目金额:510亿元</p>
			</td>
			<!-- 表格数据不够自动补全单元格 -->
			<td class="a-compare-company p-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>

		<!-- 各类企业数量对比 -->
		<tr class="compare-view">
			<td class="a-compare-company left-sticky" rowspan="4">
				<h5 class="fz16 title pdx-3 tac">各类企业数量对比</h5>
			</td>
			<td class="a-compare-company py-1 px-3" :key="i" v-for="(list,i) in compareList">
				<p>科技型中小企业：<span class="basefont curp">50家></span></p>
			</td> 
			<td class="a-compare-company px-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view">
			<td class="a-compare-company py-1 px-3" :key="i" v-for="(list,i) in compareList">
				<p>高新技术企业：<span class="basefont curp">50家></span></p>
			</td> 
			<td class="a-compare-company px-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view">
			<td class="a-compare-company py-1 px-3" :key="i" v-for="(list,i) in compareList">
				<p>专精特新中小企业：<span class="basefont curp">50家></span></p>
			</td> 
			<td class="a-compare-company px-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view">
			<td class="a-compare-company py-1 px-3" :key="i" v-for="(list,i) in compareList">
				<p>专精特新“小巨人”企业：<span class="basefont curp">50家></span></p>
			</td> 
			<td class="a-compare-company px-3"  v-for="(item,index) in  4-compareList.length" :key="index+10">-</td>
		</tr>
		</table>
	<!-- </div> --> 
	</div> 
</template>

<script>
export default {
		name: 'compare-industrial-distribution',
		data(){return{ 
			userdata:{},
		}},
		props:{
			compareList:{type:Array},
			refreshNum:{type:Number,default:1}
		},
		mounted(){
			this.compareList.forEach((item,index)=>{
				console.log('item',item);
				this.PiechartFun('compare-industrialPie'+(index+1),item.industy);
			})
		},
		methods:{
			PiechartFun(el,data) {
				console.log('piechart',el,data);
				var regionalchart = echarts.init(document.getElementById(el));
				var that = this;
				var option = {
					title: {
						text: ' ',
					},
					tooltip: {
						trigger: 'item'
					},
					// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
					// },
					series: [{
						name: '',
						type: 'pie',
						radius: '60%',
						// center: ["52%", "50%"],
						data: data,
						label: {
							show: true,
							color: '#333',
							fontSize: 12,
							position: 'outside',
							formatter: '{b} : {d}%',
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				regionalchart.setOption(option);
			},
		}
		
		
}
</script>

<style>
#compare-industrialPie1,
#compare-industrialPie2,
#compare-industrialPie3,
#compare-industrialPie4,
#compare-industrialPie5{
width: 100%;
height: 300px;
/* border: 1px solid red; */
}
.industrialPie .a-compare-company{
	width:21%;
}

</style>